var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirebaseColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.1 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f6a31f;}.cls-2{fill:#f08214;}.cls-3{fill:#fec92b;}.cls-4{fill:#f7a520;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.71,18.06l-5,4.65-4.64-9.36L16.46,8c.61-1.08,1.6-1.08,2.21,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.7 22.71 0 40.11 14.06 13.35 18.7 22.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M29.18,10.94c.89-.86,1.82-.57,2.05.65L36.1,39.88,20,49.55A7.74,7.74,0,0,1,17.9,50,7.54,7.54,0,0,1,16,49.54L0,40.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M14.06,13.35,0,40.11,6.26,1C6.49-.22,7.19-.34,7.8.74Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebaseColour);
export default __webpack_public_path__ + "static/media/Firebase_colour.fd8289a7de78b50c751fc82650db17fe.svg";
export { ForwardRef as ReactComponent };